import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';

export const conversionTypeOptions = [
    {
        value: CONVERSION_TYPE.EVENT_BASED,
        title: <FormattedMessage id="codeless.conversion.type.button.click" defaultMessage="Button Clicks" />,
        description: (
            <FormattedMessage
                id="codeless.conversion.type.button.click.description"
                defaultMessage="Track when users click on a specific button or element. For instance, you can monitor when someone clicks the 'Add to Cart' button and record this action as an 'Add to Cart' event."
            />
        ),
    },
    {
        value: CONVERSION_TYPE.BASIC,
        title: <FormattedMessage id="codeless.conversion.type.url.visits" defaultMessage="URL Visits" />,
        description: (
            <FormattedMessage
                id="codeless.conversion.type.url.visits.description"
                defaultMessage="Track when a URL containing a specific keyword is visited. For example, you can record a 'View Content' event when someone visits a URL that includes the '/product' keyword."
            />
        ),
    },
];
